module.exports = __webpack_public_path__ + "img/arrow-right.1cdf7c22.svg";